import { render, staticRenderFns } from "./ProRiskQuotationFilter.vue?vue&type=template&id=4ba8186e&"
import script from "./ProRiskQuotationFilter.vue?vue&type=script&lang=ts&"
export * from "./ProRiskQuotationFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports